import axiosInstance from '../Api/axiosInstance';

// Get all plans
export const getPlans = ({ includeInactive = false } = {}) => {
	const params = includeInactive ? { includeInactive: 'true' } : undefined;
	return axiosInstance.get('/plans', { params });
};

// Get a single plan by ID
export const getPlan = (id) => axiosInstance.get(`/plans/${id}`);

// Create a new plan
export const createPlan = (planData) => axiosInstance.post('/plans', planData);

// Update an existing plan by ID
export const updatePlan = (id, planData) =>
	axiosInstance.put(`/plans/${id}`, planData);

// Delete a plan by ID
export const deletePlan = (id) => axiosInstance.delete(`/plans/${id}`);

// Get subscription analytics (for system admin dashboard)
export const getSubscriptionAnalytics = () =>
	axiosInstance.get('/plans/analytics');
